var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaperClip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4083 1.67901C13.2894 -0.559668 9.84172 -0.559668 7.72282 1.67901L1.13493 8.6394C-0.378405 10.2385 -0.378305 12.8405 1.1352 14.4396C1.892 15.2392 2.88577 15.639 3.87994 15.6388C4.87385 15.6387 5.86809 15.2391 6.62479 14.4396L12.6635 8.05927C13.5716 7.09993 13.5717 5.53875 12.6636 4.57907C11.7554 3.61963 10.2777 3.61966 9.36973 4.57924L5.42071 8.75149C5.11753 9.07178 5.11753 9.59116 5.42064 9.91152C5.72388 10.2318 6.21536 10.2318 6.5186 9.91152L10.4677 5.73917C10.7704 5.41933 11.2629 5.41933 11.5656 5.73906C11.8683 6.05897 11.8683 6.57929 11.5655 6.89913L5.52692 13.2795C4.61875 14.2389 3.1412 14.2391 2.2331 13.2796C1.32502 12.3201 1.32492 10.7589 2.2329 9.7994L8.82075 2.83904C10.3343 1.24007 12.7969 1.24 14.3104 2.83911C15.0436 3.6137 15.4474 4.64365 15.4474 5.73913C15.4474 6.83465 15.0436 7.86456 14.3103 8.63923L7.72265 15.5997C7.41947 15.9201 7.41947 16.4394 7.72272 16.7598C7.87433 16.9199 8.07301 17 8.27167 17C8.47032 17 8.66904 16.9199 8.82065 16.7598L15.4082 9.79933C16.4347 8.71486 17 7.27295 17 5.7392C17.0001 4.20538 16.4348 2.76347 15.4083 1.67901Z",
    fill: "#777777"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperClip);
export default __webpack_public_path__ + "static/media/paperClip.54781a2c80b61b65085ab3169cc35a17.svg";
export { ForwardRef as ReactComponent };